module.exports = __webpack_public_path__ + "static/media/cleartable.09db4f56.svg";